import React from "react";
import Picker from "react-mobile-picker";
import { Icon } from "@cc/react-components";

interface ExtendedPickerProps {
  /** Object containing the selected values per group*/
  valueGroups: any;
  /** Object containing the possible options per group */
  optionGroups: any;
  /** Callback when a value is changed. Name: name of the group that is changed. Value: the new value */
  handleChange?: (name: string, value: any) => void;
  /** Callback when the confirm checkmark button is clicked. */
  handleConfirm?: () => void;
  /** Controls that are put on the left hand side of the top menu bar (next to the confirm checkmark) */
  leftMenuBarControls?: any;
}

const ExtendedPicker = ({
  valueGroups,
  optionGroups,
  handleChange,
  handleConfirm,
  leftMenuBarControls,
}: ExtendedPickerProps) => {
  const handleChangeCallback = (name: string, value: any) => {
    handleChange != null && handleChange(name, value);
  };

  const handleConfirmCallback = (): any => {
    handleConfirm != null && handleConfirm();
  };

  return (
    <div className="d-flex flex-column w-100">
      <div
        className="d-flex justify-content-end "
        style={{ backgroundColor: "#17283c" }}
      >
        <Icon
          type="checkmark"
          size="2x"
          className="text-white px-4"
          onClick={handleConfirmCallback}
        />
        {leftMenuBarControls && { leftMenuBarControls }}
      </div>
      <Picker
        optionGroups={optionGroups}
        valueGroups={valueGroups}
        onChange={handleChangeCallback}
      />
    </div>
  );
};

export default ExtendedPicker;
